import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { registerAction2 } from 'vscode/vscode/vs/platform/actions/common/actions';
import { Extensions } from 'vscode/vscode/vs/platform/configuration/common/configurationRegistry';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { EditorPaneDescriptor } from 'vscode/vscode/vs/workbench/browser/editor';
import { registerWorkbenchContribution2 } from 'vscode/vscode/vs/workbench/common/contributions';
import { EditorExtensions } from 'vscode/vscode/vs/workbench/common/editor';
import { MultiDiffEditor } from './multiDiffEditor.js';
import { MultiDiffEditorResolverContribution, MultiDiffEditorInput, MultiDiffEditorSerializer } from 'vscode/vscode/vs/workbench/contrib/multiDiffEditor/browser/multiDiffEditorInput';
import { GoToFileAction, CollapseAllAction, ExpandAllAction } from './actions.js';
import 'vscode/vscode/vs/base/common/lifecycle';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { OpenScmGroupAction, ScmMultiDiffSourceResolverContribution } from 'vscode/vscode/vs/workbench/contrib/multiDiffEditor/browser/scmMultiDiffSourceResolver';

const _moduleId = "vs/workbench/contrib/multiDiffEditor/browser/multiDiffEditor.contribution";
registerAction2(GoToFileAction);
registerAction2(CollapseAllAction);
registerAction2(ExpandAllAction);
( (Registry.as(Extensions.Configuration)))
    .registerConfiguration({
    properties: {
        'multiDiffEditor.experimental.enabled': {
            type: 'boolean',
            default: true,
            description: 'Enable experimental multi diff editor.',
        },
    }
});
registerWorkbenchContribution2(MultiDiffEditorResolverContribution.ID, MultiDiffEditorResolverContribution, 1 );
( (Registry.as(EditorExtensions.EditorPane)))
    .registerEditorPane(EditorPaneDescriptor.create(MultiDiffEditor, MultiDiffEditor.ID, ( localizeWithPath(_moduleId, 0, "Multi Diff Editor"))), [( (new SyncDescriptor(MultiDiffEditorInput)))]);
( (Registry.as(EditorExtensions.EditorFactory)))
    .registerEditorSerializer(MultiDiffEditorInput.ID, MultiDiffEditorSerializer);
registerAction2(OpenScmGroupAction);
registerWorkbenchContribution2(ScmMultiDiffSourceResolverContribution.ID, ScmMultiDiffSourceResolverContribution, 1 );
